// BreadcrumbContext.js
import { createContext, useContext, useState } from "react";

const BreadcrumbContext = createContext();

export const BreadcrumbProvider = ({ children }) => {
  const [breadcrumbProps, setBreadcrumbProps] = useState({
    additionalBreadcrumbs: [],
    useDefaultPath: true,
    data: {},
    orgName: "",
    schoolName: "",
  });

  return (
    <BreadcrumbContext.Provider value={{ breadcrumbProps, setBreadcrumbProps }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = () => useContext(BreadcrumbContext);